import { Card, CardBody } from 'reactstrap';

const SummaryWidget = ({
    title,
    value,
    status,
    cardStyle,
}) => {
    const isStatusWidget = Boolean(status);

    return (
        <Card className="h-100 mb-0 shadow-sm" style={cardStyle}>
            <CardBody
                className={
                    isStatusWidget
                        ? 'h-100'
                        : 'd-flex flex-column justify-content-center text-center h-100'
                }
            >
                <p className="ppwr-summary-widget__title mb-4">
                    {title}
                </p>

                {isStatusWidget ? (
                    <div className="d-flex align-items-center gap-2">
                        <span
                            className="ppwr-summary-widget__status-dot flex-shrink-0"
                            style={{ backgroundColor: status.color }}
                        />
                        <span
                            className="ppwr-summary-widget__status-text"
                            style={{ color: status.color }}
                        >
                            {status.label}
                        </span>
                    </div>
                ) : (
                    <h4 className="ppwr-summary-widget__value mb-0">
                        {value}
                    </h4>
                )}
            </CardBody>
        </Card>
    );
};

export default SummaryWidget;
